import { company } from '../data/company'
import { cities } from '../data/cities'

const SITE_URL = 'https://google.com'

export function localBusinessSchema(cityName?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    name: company.name,
    image: company.logo,
    telephone: company.phone,
    email: company.email,
    url: SITE_URL,
    priceRange: '$$',
    slogan: company.tagline.en,
    address: {
      '@type': 'PostalAddress',
      addressLocality: cityName ?? 'Shelton',
      addressRegion: 'WA',
      addressCountry: 'US',
    },
    areaServed: cities.map((city) => ({
      '@type': 'City',
      name: `${city.name}, WA`,
    })),
    knowsLanguage: ['en', 'es'],
    openingHours: 'Mo-Sa 07:00-19:00',
  }
}

export function serviceSchema(name: string, description: string, cityName?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: name,
    description,
    provider: {
      '@type': 'HomeAndConstructionBusiness',
      name: company.name,
      telephone: company.phone,
    },
    areaServed: cityName ? `${cityName}, WA` : 'Washington State',
  }
}

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  }
}

export function faqSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  }
}
